<template>
    <div>
        <v-layout wrap align-center justify-center class="px-2">
            <v-flex xs12 class="pb-3">
                <div class="title primary--text">
                    <h4>{{ $t("enrollment.steps.phone.component.title") }}</h4>
                </div>
            </v-flex>
            <v-flex xs12 mb-2>
                <VuePhoneNumberInput
                class="custom-input"
                @update="setPhoneNumber"
                :no-example="true"
                :translations="Optionaltranslations"
                :show-code-on-list="true"
                :countries-height="30"
                :default-country-code="country_code"
                v-model="formattedNumber"
                size="lg"
                :dark="darkMode"
                />
            </v-flex>
            <!-- Login with password -->
            <div class="py-4 text-xs-center">
                <a @click.stop="goToStep(DEFINES.ENROLLMENT_STEPS.ASK_PASSWORD)">
                    <strong class="primary--text subheading">
                        {{ $t(`${eventPrefix}.login_with_password.label`) }}
                    </strong>
                </a>
            </div>
        </v-layout>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
            :class="[$vuetify.rtl ? 'ml-2' : '']"
            color="primary background--text"
            dark
            @click="onCancel"
            >{{ $t(`${eventPrefix}.btn.cancel`) }}</v-btn
            >
            <v-btn
            :class="[$vuetify.rtl ? 'mx-0' : '']"
            color="primary background--text"
            dark
            @click="onConfirm"
            >{{ $t("enrollment.steps.send_code.button") }}</v-btn
            >
        </v-card-actions>
    </div>
</template>

<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import { mapGetters } from "vuex";

export default {
    name:"EnrollmentAskPhone",
    props:{
        eventPrefix: {
            type: String,
            default: 'screener'
        },
        country_code: {
            type: String,
            default: null
        }
    },
    data(){
        return{
            formattedNumber: null,
            Optionaltranslations: {
                phoneNumberLabel: this.$t("screening.register.lable.phone.optional"),
            },
        }
    },
    components:{
        VuePhoneNumberInput
    },
    computed:{
        ...mapGetters("app", {
            darkMode: "darkMode"
        })
    },
    methods:{
        goToStep(step){
            this.$emit("onChange",step);
        },
        setPhoneNumber(payload){
            this.$emit("onSetPhone",payload);
        },
        onCancel(){
            this.$emit("onCancel");
        },
        onConfirm(){
            this.$emit("onConfirm",true);
        }
    }
}
</script>

<style>

</style>
